import { createApp } from 'vue'


import App from './App.vue'

import router from "./router"
// 引入less
import less from 'less'

import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import * as echarts from 'echarts';
import 'echarts-gl';

import vue3SeamlessScroll from "vue3-seamless-scroll";

import locale from "element-plus/lib/locale/lang/zh-cn";//需要新加的代码

const app = createApp(App)

app.config.globalProperties.$echarts = echarts 

app.use(router)
app.use(vue3SeamlessScroll)
app.use(less)
app.use(ElementPlus,{locale})
app.mount('#app')